import queryString from "query-string";

export const getParsedQueryParams = urlSearch => {
  return queryString.parse(urlSearch);
};
